const INITIAL_STATE = {
	aguardando: false,
	lista: []
}

export default function(state = INITIAL_STATE, action) {
    switch (action.type) {

		case 'DASHBOARD_SET_AGUARDANDO':
			return { ...state,
				aguardando: action.payload
			};

		case 'DASHBOARD_CLIENTE_LISTADO':
			return { ...state, lista: action.payload.data };

        default:
            return state;
    }
}
